import { Circle, Fill, Stroke, Style } from 'ol/style';
import { type Type as GeometryType } from 'ol/geom/Geometry';
import { getAtonStyle, getVirtualAtonStyle } from './getStyle';

export enum DrawingStyles {
  Normal = 'normal',
  aton = 'aton',
  VirtualAton = 'virtualAton',
  InnerArea = 'innerArea',
}

export function getDrawingStyle(
  drawingStyle: DrawingStyles,
  geometryType: GeometryType,
): Style[] {
  if (drawingStyle === DrawingStyles.VirtualAton) {
    return [getVirtualAtonStyle()];
  } else if (drawingStyle === DrawingStyles.aton) {
    return [getAtonStyle()];
  } else if (drawingStyle === DrawingStyles.InnerArea) {
    return [
      new Style({
        image: new Circle({
          radius: 5,
          fill: new Fill({ color: 'rgba(249, 115, 22, 0.4)' }),
          stroke: new Stroke({ color: '#f97316', width: 1.5 }),
        }),
        fill: new Fill({ color: 'rgba(249, 115, 22, 0.3)' }),
        stroke: new Stroke({ color: '#f97316', width: 2 }),
      }),
    ];
  } else {
    switch (geometryType) {
      case 'Point':
        return [
          new Style({
            image: new Circle({
              radius: 5,
              fill: new Fill({
                color: 'rgba(249, 115, 22, 0.4)',
              }),
              stroke: new Stroke({
                color: '#f97316',
                width: 1.5,
              }),
            }),
          }),
        ];

      case 'LineString':
        return [
          new Style({
            image: new Circle({
              radius: 5,
              fill: new Fill({
                color: 'rgba(249, 115, 22, 0.4)',
              }),
              stroke: new Stroke({
                color: '#f97316',
                width: 1.5,
              }),
            }),
            stroke: new Stroke({
              color: '#f97316',
              width: 2,
            }),
          }),
        ];

      case 'Polygon':
        return [
          new Style({
            image: new Circle({
              radius: 5,
              fill: new Fill({
                color: 'rgba(249, 115, 22, 0.4)',
              }),
              stroke: new Stroke({
                color: '#f97316',
                width: 1.5,
              }),
            }),
            fill: new Fill({
              color: 'rgba(249, 115, 22, 0.15)',
            }),
            stroke: new Stroke({
              color: '#f97316',
              width: 2,
            }),
          }),
        ];

      case 'Circle':
        return [
          new Style({
            image: new Circle({
              radius: 5,
              fill: new Fill({
                color: 'rgba(249, 115, 22, 0.4)',
              }),
              stroke: new Stroke({
                color: '#f97316',
                width: 1.5,
              }),
            }),
            fill: new Fill({
              color: 'rgba(249, 115, 22, 0.15)',
            }),
            stroke: new Stroke({
              color: '#f97316',
              width: 2,
            }),
          }),
        ];

      default:
        return [
          new Style({
            stroke: new Stroke({
              color: '#f97316',
              width: 2,
            }),
          }),
        ];
    }
  }
}
